const plans = () =>
  import("@/components/dashSetting/subscription/subscriptionPlansDashboard");
const mySubscription = () =>
  import("@/components/dashSetting/subscription/mySubscriptionDashboard");
const managePassword = () => import("@/components/dashSetting/settingSecurity");
const digitalSignature = () =>
  import("@/components/dashSetting/digitalSignatureMain");
const privacySetting = () => import("@/components/dashSetting/privacySetting");
const manageProfile = () => import("@/components/dashSetting/manageProfile");
const requestLogInfo = () => import("@/components/dashSetting/requestLogInfo");
const dataStorage = () => import("@/components/dashSetting/dataStorage");
export default [
  // {
  //   path: "",
  //   name: "settings.manage.root",
  //   redirect: {
  //     name: "settings.manage"
  //   }
  //   // component: Dashboard
  // },
  {
    path: "subscription/plans",
    name: "settings.subscription.plans",
    component: plans
  },
  {
    path: "subscription/my-subscription",
    name: "settings.subscription.my-subscription",
    component: mySubscription
  },
  {
    path: "security/manage-password",
    name: "settings.security.manage-password",
    component: managePassword
  },
  {
    path: "security/digital-signature",
    name: "settings.security.digital-signature",
    component: digitalSignature
  },
  {
    path: "privacy",
    name: "settings.privacy",
    component: privacySetting
  },
  {
    path: "manage-profile",
    name: "settings.manage-profile",
    component: manageProfile
  },
  {
    path: "request-log-info",
    name: "settings.request-log-info",
    component: requestLogInfo
  },
  {
    path: "data-and-storage",
    name: "settings.data-and-storage",
    component: dataStorage
  }
];
